import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="classification-variants"
//
// Targets:
//   masterToggle  - <input type="checkbox"> "Zobraziť všetky varianty"
//   list          - the <ul> wrapping the per-variant rows (we toggle opacity)
//   checkbox      - each per-variant <input type="checkbox">
//
// Rules:
//   - masterToggle is UX-only. On submit, when it's checked, every variant
//     checkbox is unchecked so the form submits an empty visible_variant_ids[].
//   - Checking any variant box auto-disables the master toggle.
//   - Toggling the master back on clears the variant boxes.
//   - When all variants happen to be checked manually, master stays OFF
//     (explicit selection is not the same state as implicit "all").

export default class extends Controller {
  static targets = ["masterToggle", "list", "checkbox"];

  connect() {
    this.syncFromMaster();
  }

  toggleMaster() {
    if (this.masterToggleTarget.checked) {
      this.checkboxTargets.forEach((cb) => (cb.checked = false));
    }
    this.syncFromMaster();
  }

  selectVariant() {
    if (this.checkboxTargets.some((cb) => cb.checked)) {
      this.masterToggleTarget.checked = false;
      this.syncFromMaster();
    }
  }

  syncFromMaster() {
    const disabled = this.masterToggleTarget.checked;
    this.listTarget.classList.toggle("opacity-50", disabled);
    this.checkboxTargets.forEach((cb) => (cb.disabled = disabled));
  }
}
